import {
  pdfJobFailedSchema,
  pdfJobPendingSchema,
  pdfJobReadySchema,
  pdfNotReadySchema,
} from "@reactive-resume/schema";
import { createZodDto } from "nestjs-zod/dto";

export class PdfJobPendingDto extends createZodDto(pdfJobPendingSchema) {}

export class PdfJobReadyDto extends createZodDto(pdfJobReadySchema) {}

export class PdfJobFailedDto extends createZodDto(pdfJobFailedSchema) {}

export class PdfNotReadyDto extends createZodDto(pdfNotReadySchema) {}

export type {
  PdfJobFailed,
  PdfJobPending,
  PdfJobReady,
  PdfJobStatus,
  PdfNotReady,
} from "@reactive-resume/schema";
